import { useState } from "react";
import ButtonIcon from "../common/buttonIcon"
import { useTranslation } from "react-i18next";
import { isGroupLinkChild, isGroupLinkParent } from "../../utils/helpers";
const BoxService = (props: any) => {
  const { t } = useTranslation();

  let id = props.id ?? "";
  let title = props.title ?? "";
  let external = props.external ?? false;
  let deletable = props.deletable ?? false;
  let disabled = props.disabled ?? false;
  let groupLink = props.groupLink;
  const isParent = isGroupLinkParent(groupLink);
  const isChild = isGroupLinkChild(groupLink);
  const [status, setStatus] = useState(1);
  const toggleClick = () => {
    if (status) {
      setStatus(0);
    }
    else {
      setStatus(1);
    }
    props.toggleClick(id, status);
  }

  // Different title rendering.
  const DefaultTitle = <div className="col-lg-6 p-0">
    <p className="p-1 fw-bold">
      {title}
    </p>
  </div>;
  const ParentTitle = <div className="col-lg-6 p-0">
    <p className="p-1 mb-1 fw-bold">
      {title}
    </p>
  </div>;
  const ChildrenTitle = <div className="col-lg-7 p-0">
    <p className="p-1 mb-1">
      <small>{title}</small>
    </p>
  </div>;

  return (
    <div className="row m-0 "  >
      {/* Children indentation */}
      {isChild && <div className="p-0 col-lg-1"></div>}

      <div className="col-lg-1 p-0">
        <div className={`Marker   ${status ? "Active" : ""}`} onClick={toggleClick}>
        </div>
      </div>

      {/* Different title rendering. */}
      {!isParent && !isChild && DefaultTitle}
      {isParent && ParentTitle}
      {isChild && ChildrenTitle}

      {/* Buttons rendering. */}
      <div className={`text-right ${isChild ? "col-lg-3" : "col-lg-5"}`}>
        {(!external && !isChild) && <ButtonIcon
          title={((!deletable) ? t('not-service-delete') : "")}
          disabled={!deletable}
          handleClick={() => { props.handleDelete(id, title) }}
          icon="delete"
        />}

        {(!isChild) && <ButtonIcon
          disabled={disabled}
          title={disabled ? t('service-disabled-description') : ''}
          handleClick={() => { props.handleClickEdit(id) }}
          icon="edit_calendar"
        />}

        <ButtonIcon
          disabled={disabled}
          title={disabled ? t('service-disabled-description') : ''}
          handleClick={() => { props.handleClickSettings(id) }}
          icon="settings"
        />
      </div>
    </div >
  )
}

export default BoxService